import React from 'react';


export const AwsGeneric = props => {
    return (
        <svg className={props.className} width="24" height="24" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path d="M0 19.0333L1.53019 19.6666L1.78125 19.2976V4.6044L1.53019 4.33325L0 4.96658V19.0333Z"
                  fill="#9D5025"/>
            <path d="M4.46892 4.93321L1.5293 4.33325V19.6666L4.46892 19.0999V4.93321Z" fill="#F68536"/>
            <path d="M13.4902 6.09993L15.5841 5.19995L22.5506 7.43324L20.6983 7.63323L13.4902 6.09993Z" fill="#6B3A19"/>
            <path d="M13.5703 17.9001L15.624 18.8001L22.5904 16.5668L20.7381 16.3667L13.5703 17.9001Z" fill="#FBBF93"/>
            <path d="M14.0938 15.4334L17.7582 15.8334L17.9685 15.5209V8.53653L17.7582 8.16675L14.0938 8.56672V15.4334Z"
                  fill="#9D5025"/>
            <path d="M3.3418 3.56665L5.59686 2.6333L5.84323 3.02652V20.9531L5.59686 21.3666L3.3418 20.4333V3.56665Z"
                  fill="#9D5025"/>
            <path d="M10.1882 20.1L5.59766 21.3333V2.6333L10.1882 3.86666V20.1Z" fill="#F68536"/>
            <path d="M8.41602 22.5L11.9999 24L12.3749 23.6434V0.439782L11.9999 0L8.41602 1.50001V22.5Z" fill="#9D5025"/>
            <path d="M20.6172 7.63334L22.4696 7.43335L22.6287 7.62464V16.3745L22.4696 16.6L20.6172 16.4V7.63334Z"
                  fill="#9D5025"/>
            <path d="M17.7578 8.16675V15.8667L21.5833 12.0001L17.7578 8.16675Z" fill="#F68536"/>
            <path
                d="M22.4698 4.33334L12 0V24L24 19.0333V4.96666L22.4698 4.33334ZM22.4698 16.6116L15.5839 18.3139V5.68605L22.4698 7.38838V16.6116Z"
                fill="#F68536"/>
        </svg>
    )
};
